AgrimarketServices.service('typeOptionsService', [ '$http', 'configurationFactory',
    function ( $http, configurationFactory) {

    	var SendRequest = function (configfile, callback) {
    		$http(configfile)
			    .success(function (data) {
			    	callback(data, null);
			    })
			    .error(function (data, status) {
			    	callback(data, status);
			    });
    	};

    	this.GetTypeOptions = function (callback) {
    		var config = {
    			method: 'GET',
    			url: configurationFactory.Url['Api'] + 'TypeOption/GetAll'
    		};
    		SendRequest(config, callback);
    	};
    }]);